import { apiClient as dataApi } from "../api/client";

function buildIikoPeriodBody(id, dateFrom, dateTo, groupByRestaurant = false, restaurantGroup = null) {
  const body = {
    id,
    dateFrom,
    dateTo,
    groupByRestaurant: Boolean(groupByRestaurant),
  };
  // No trim() on the value itself — it's iiko's exact group name and goes
  // straight into a server-side IncludeValues filter. A group whose name has
  // trailing/leading whitespace in iiko (seen in practice, e.g. "Касса №2 ")
  // would otherwise never match and silently return an empty report.
  if (restaurantGroup != null && String(restaurantGroup).trim() !== "") {
    body.restaurantGroup = String(restaurantGroup);
  }
  return body;
}

class DatasRequest {
  async getIikoData(id, dateFrom, dateTo, groupByRestaurant = false, restaurantGroup = null) {
    const response = await dataApi.post(
      "/dash/iiko/getdatas",
      buildIikoPeriodBody(id, dateFrom, dateTo, groupByRestaurant, restaurantGroup),
    );
    return response.data;
  }

  /** groupByRestaurant без restaurantGroup — список групп; с restaurantGroup — данные по дням для группы */
  async getIikoOlapData(id, dateFrom, dateTo, groupByRestaurant = false, restaurantGroup = null) {
    const response = await dataApi.post(
      "/dash/iiko/olapdatas",
      buildIikoPeriodBody(id, dateFrom, dateTo, groupByRestaurant, restaurantGroup),
    );
    return response.data;
  }

  async getWaitersDatas(id, dateFrom, dateTo, groupByRestaurant = false, restaurantGroup = null) {
    const response = await dataApi.post(
      "/dash/iiko/getwaiters",
      buildIikoPeriodBody(id, dateFrom, dateTo, groupByRestaurant, restaurantGroup),
    );
    return response.data;
  }

  async getIikoEventsFilter(body) {
    const response = await dataApi.post("/dash/iiko/eventsfilter", body);
    return response.data;
  }

  async getIikoCashShifts(body) {
    const response = await dataApi.post("/dash/iiko/cashshifts", body);
    return response.data;
  }
}

const dataRequest = new DatasRequest();

export default dataRequest;
